import styled from '@emotion/styled';
import { COLORS } from "../../constants/Theme";
const generateBorderRadius = (props) => {
    if (props.selectRange) {
        return `
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    `;
    }
    else {
        return `
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    `;
    }
};
export const PickerContainer = styled.div `
	position: relative;
	z-index: 99999;

	.react-calendar {
		background: ${COLORS.text.white};
		border-width: 1px;
		border-style: solid;
		border-color: ${COLORS.text.white};
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
		border-radius: 4px;
		color: ${COLORS.text.primary};
		&--selectRange {
			.react-calendar {
				&__year-view {
					.react-calendar__tile--hover {
						background-color: unset;
					}
				}
				&__month-view {
					.react-calendar__tile--hover {
						background-color: ${COLORS.background.brandLight};
					}
				}
			}
		}
		.react-calendar {
			&__tile {
				transition: all 0.25s;
				&:enabled:hover {
					background-color: ${COLORS.surface.hovered};
					border-radius: 4px;
				}
				&--hasActive:enabled:hover,
				&--hasActive:enabled:focus {
					background: ${COLORS.background.brand};
					color: ${COLORS.text.white};
				}
				&.react-calendar__tile {
					&--range {
						&:enabled:hover {
							border-radius: 0;
						}
					}
					&--rangeStart {
						border-top-right-radius: 0;
						border-bottom-right-radius: 0;
						border-top-left-radius: 4px !important;
						border-bottom-left-radius: 4px !important;
						background: ${COLORS.background.brand};
						color: ${COLORS.text.white};

						&:enabled:hover {
							border-top-right-radius: 0;
							background: ${COLORS.background.brand};
							border-color: ${COLORS.background.brand};
							border-bottom-right-radius: 0;
						}
						&.react-calendar__tile--rangeEnd {
							${(props) => generateBorderRadius(props)}
							border-top-left-radius: 4px;
							border-bottom-left-radius: 4px;
							&:enabled:hover {
								background: ${COLORS.background.brand};
								border-color: ${COLORS.background.brand};
								border-top-right-radius: 0;
								border-bottom-right-radius: 0;
								border-top-left-radius: 4px !important;
								border-bottom-left-radius: 4px !important;
							}
						}
					}
					&--rangeEnd {
						border-top-left-radius: 0;
						border-bottom-left-radius: 0;
						border-top-right-radius: 4px !important;
						border-bottom-right-radius: 4px !important;
						background: ${COLORS.background.brand};
						color: ${COLORS.text.white};

						&:enabled:hover {
							border-top-left-radius: 0;
							background: ${COLORS.background.brand};
							border-color: ${COLORS.background.brand};
							border-bottom-left-radius: 0;
						}
					}
				}
			}
		}

		.react-calendar__tile--active {
			background: ${COLORS.background.brandLight};
			color: ${COLORS.text.primary};
		}

		.react-calendar__tile--now {
			background: ${COLORS.text.white};
			border-radius: 4px;
			border-color: ${COLORS.background.brand};
			border-style: solid;
			border-width: 1px;
		}

		.react-calendar__month-view__weekdays__weekday {
			font-style: normal;
			overflow: hidden;
			font-weight: 600;
			font-size: 14px;
			line-height: 20px;
			color: ${COLORS.text.primary};

			abbr[title] {
				text-decoration: none !important;
			}
		}

		.react-calendar__navigation button:enabled:hover,
		.react-calendar__navigation button:enabled:focus {
			background-color: ${COLORS.background.brandLight};
			border-radius: 4px;
		}

		.react-calendar__month-view__weekends {
			color: ${COLORS.text.primary};
		}

		.react-calendar__month-view__days__day--weekend {
			color: ${COLORS.text.primary};
		}

		.react-calendar__month-view__weekdays {
			background: ${COLORS.surface.subdued};
		}

		.react-calendar__navigation {
			display: flex;
			padding: 12px 20px;

			button {
				border: 0 !important;
				background: transparent !important;
			}

			.react-calendar__navigation__arrow
				react-calendar__navigation__prev2-button {
				font-size: 20px;
			}

			.react-calendar__navigation__arrow
				react-calendar__navigation__prev-button {
				font-size: 20px;
			}
		}
		.react-calendar__tile:disabled {
			background-color: #f0f0f0 !important;
		}
	}
`;
//# sourceMappingURL=DatePicker.styled.js.map